export default __webpack_public_path__ + "static/media/microsoft-edge.565df3da.svg";